export default "__VITE_ASSET__Dyf2PXn___"